export const CHATBOT_SETTINGS_QUERY_KEY = 'chatbot-settings';
